goog.provide('el8.data.noteSettings');

goog.require('el8.service.urls');
goog.require('el8.model.base');

el8.data.noteSettings = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('defaultVisitNoteTemplate', true);

    var _apptTypeClass = function(spec) { this.populate(spec); };
    _apptTypeClass.inheritsFrom(el8_Entity);
    _apptTypeClass.addIntProperty('apptTypeId');
    _apptTypeClass.addStringProperty('visitTemplate');

    _class.addModelSetProperty('apptTypeSettings', function(spec) { return new _apptTypeClass(spec); }, false, []);

    _class.prototype.updateVisitNoteTemplate = function(template, successCb) {
        var that = this;
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('noteSettings', [el8.data.currPractice.getId(), el8.data.currUser.getId()]),
            data: {data: JSON.stringify({'default_visit_note_template': template})},
            success: function(data) {
                if (data) { that.populate(data); }
                if (successCb) { successCb(); }
            }
        });
    };

    _class.prototype.updateApptType = function(apptTypeId, template, successCb) {
        var that = this;
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('updateApptTypeNoteSettings', [el8.data.currPractice.getId(), el8.data.currUser.getId(), apptTypeId]),
            data: {data: JSON.stringify({'visit_note_template': template})},
            success: function(data) {
                that.setApptTypeSettings(data);
                if (successCb) { successCb(); }
            }
        });
    };

    _class.prototype.getApptTypeVisitNoteById = function(apptTypeId) {
        var settings = this.getApptTypeSettings();
        for (var i=0; i<settings.length; i++) {
            if (settings[i].getApptTypeId() === apptTypeId) {
                return settings[i].getVisitTemplate();
            }
        }
        return null;
    };

    var that = new _class({});
    that.load = function(async) {
        $.el8_ajax({
            type: 'GET',
            async: async,
            url: el8.service.urls.get('noteSettings', [el8.data.currPractice.getId(), el8.data.currUser.getId()]),
            success: function(data) {
                that.populate(data);
            }
        });
    };

    return that;

})();

